import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { ApiService } from 'src/app/providers/api.service';
import { LoaderServiceService } from 'src/app/providers/loader-service.service';
import { NavigationService } from 'src/app/providers/navigation.service';
import { SM_CONSTANTS } from 'src/app/shared/constants/sm-constants';

@Component({
  selector: 'sm-add-joining-interest-timings',
  templateUrl: './add-joining-interest-timings.component.html',
  styleUrls: ['./add-joining-interest-timings.component.scss']
})
export class AddJoiningInterestTimingsComponent implements OnInit {

  serviceType: string = '';
  entityHashId: string = '';
  loader: boolean = false;
  apisub: Subscription
  businessListData: any[] = []
  serviceTimings: any[] = []
  finalServiceTimings: any[] = []
  selectedBusiness:any
  selectedServiceType: any = '0'
  groupedServiceTimings:any = null
  toShowTimings: boolean = false
  daysArray:any =[
    {
        "dayName": "Sunday",
        "day": 1,
        "timeSlots": [
            {
                "openTime": "09:00 AM",
                "closeTime": "09:00 PM"
            }
        ],
        "is_selected": 0
    },
    {
        "dayName": "Monday",
        "day": 2,
        "timeSlots": [
            {
                "openTime": "09:00 AM",
                "closeTime": "09:00 PM"
            }
        ],
        "is_selected": 0
    },
    {
        "dayName": "Tuesday",
        "day": 3,
        "timeSlots": [
            {
                "openTime": "09:00 AM",
                "closeTime": "09:00 PM"
            }
        ],
        "is_selected": 0
    },
    {
        "dayName": "Wednesday",
        "day": 4,
        "timeSlots": [
            {
                "openTime": "09:00 AM",
                "closeTime": "09:00 PM"
            }
        ],
        "is_selected": 0
    },
    {
        "dayName": "Thursday",
        "day": 5,
        "timeSlots": [
            {
                "openTime": "09:00 AM",
                "closeTime": "09:00 PM"
            }
        ],
        "is_selected": 0
    },
    {
        "dayName": "Friday",
        "day": 6,
        "timeSlots": [
            {
                "openTime": "09:00 AM",
                "closeTime": "09:00 PM"
            }
        ],
        "is_selected": 0
    },
    {
        "dayName": "Saturday",
        "day": 7,
        "timeSlots": [
            {
                "openTime": "09:00 AM",
                "closeTime": "09:00 PM"
            }
        ],
        "is_selected": 0
    },
]
  daysOfWeek = [
    { day: 1, name: 'Sunday' },
    { day: 2, name: 'Monday' },
    { day: 3, name: 'Tuesday' },
    { day: 4, name: 'Wednesday' },
    { day: 5, name: 'Thursday' },
    { day: 6, name: 'Friday' },
    { day: 7, name: 'Saturday' }
  ];
  constructor(
    private apiservice: ApiService,
    private loaderservice: LoaderServiceService,
    private navservice: NavigationService,
    private router: Router,
    private _modelRef: MatDialog,
    private dialog:MatDialog,
    private route: ActivatedRoute,
    @Inject(MAT_DIALOG_DATA) public parentdata: any,
    private activemodal: MatDialogRef<AddJoiningInterestTimingsComponent>

  ) { 
    this.apisub = this.apiservice.apiResult.subscribe(resdata => {

      if(resdata.responseType === SM_CONSTANTS.RESULT_API_GET_HOME_SERVICE_TIMINGS){
        this.serviceTimings = []
        this.daysArray = []
        this.groupedServiceTimings = null
        this.toShowTimings = false
        if(resdata.result){
          resdata.result.forEach((element:any) => {
            element.timeList = JSON.parse(element.timeList)
          });
  
          console.log(resdata.result);
  
        resdata.result.forEach((element:any) => {
          if(element.timeList.length > 1){
            element.timeList.forEach((childItem:any, index:number) => {
              childItem.toShowType = index == 0 ? 'parent' : 'child'
              childItem.closeTime = this.convertTo12HourFormat(childItem.closeTime)
              childItem.openTime = this.convertTo12HourFormat(childItem.openTime)
              this.serviceTimings.push(childItem)
            });
          }else{
            element.timeList[0].toShowType = 'parent'
            element.timeList[0].closeTime = this.convertTo12HourFormat(element.timeList[0].closeTime)
            element.timeList[0].openTime = this.convertTo12HourFormat(element.timeList[0].openTime)
            this.serviceTimings.push(element.timeList[0])
          }
          
        });
  
        console.log(this.serviceTimings);
        
        this.finalServiceTimings = []
        for (let index = 0; index < this.daysOfWeek.length; index++) {
          let dayFound = false; // Flag to keep track if the day was found in serviceTimings
        
          for (let j = 0; j < this.serviceTimings.length; j++) {
            if (this.daysOfWeek[index].day === this.serviceTimings[j].day) {
              this.serviceTimings[j].status = 1;
              this.serviceTimings[j].dayName = this.daysOfWeek[index].name 
              this.finalServiceTimings.push(this.serviceTimings[j]);
              dayFound = true;
            }
          }
        
          if (!dayFound) {
            let data = {
              day: this.daysOfWeek[index].day,
              dayName: this.daysOfWeek[index].name,
              hashId: null,
              openTime: '---',
              closeTime: '---',
              operationDate: null,
              specialDayStatus: null,
              toShowType: 'parent',
              status: 0
            };
            this.finalServiceTimings.push(data);
          }
        }
        console.log(this.finalServiceTimings);
        this.groupedServiceTimings = this.groupBy(this.finalServiceTimings, 'dayName');
        this.daysArray = this.getDayNamesFromData(this.finalServiceTimings)
        this.toShowTimings = true
       }
      //  else{
      //   this.finalServiceTimings = []
      //   for (let index = 0; index < this.daysOfWeek.length; index++) {
      //     // let dayFound = false; 
      //     // for (let j = 0; j < this.serviceTimings.length; j++) {
      //     //   if (this.daysOfWeek[index].day === this.serviceTimings[j].day) {
      //     //     this.serviceTimings[j].status = 1;
      //     //     this.serviceTimings[j].dayName = this.daysOfWeek[index].name 
      //     //     this.finalServiceTimings.push(this.serviceTimings[j]);
      //     //     dayFound = true;
      //     //   }
      //     // }
        
         
      //       let data = {
      //         day: this.daysOfWeek[index].day,
      //         dayName: this.daysOfWeek[index].name,
      //         hashId: null,
      //         openTime: '---',
      //         closeTime: '---',
      //         operationDate: null,
      //         specialDayStatus: null,
      //         toShowType: 'parent',
      //         status: 0
      //       };
      //       this.finalServiceTimings.push(data);
        
      //   }
      //   this.groupedServiceTimings = this.groupBy(this.finalServiceTimings, 'dayName');
      //   this.toShowTimings = false
      //  }
       
       
       this.loaderservice.showLoader = false
       this.loader = false
       
      }
      else if(resdata.responseType === SM_CONSTANTS.RESULT_API_GET_SHOP_SERVICE_TIMINGS){
        this.serviceTimings = []
        this.daysArray = []
        this.groupedServiceTimings = null
        this.toShowTimings = false
        if(resdata.result){
          resdata.result.forEach((element:any) => {
            element.timeList = JSON.parse(element.timeList)
          });
  
          console.log(resdata.result);
  
        resdata.result.forEach((element:any) => {
          if(element.timeList.length > 1){
            element.timeList.forEach((childItem:any, index:number) => {
              childItem.toShowType = index == 0 ? 'parent' : 'child'
              childItem.closeTime = this.convertTo12HourFormat(childItem.closeTime)
              childItem.openTime = this.convertTo12HourFormat(childItem.openTime)
              this.serviceTimings.push(childItem)
            });
          }else{
            element.timeList[0].toShowType = 'parent'
            element.timeList[0].closeTime = this.convertTo12HourFormat(element.timeList[0].closeTime)
            element.timeList[0].openTime = this.convertTo12HourFormat(element.timeList[0].openTime)
            this.serviceTimings.push(element.timeList[0])
          }
          
        });
  
        console.log(this.serviceTimings);
        
        this.finalServiceTimings = []
        for (let index = 0; index < this.daysOfWeek.length; index++) {
          let dayFound = false; // Flag to keep track if the day was found in serviceTimings
        
          for (let j = 0; j < this.serviceTimings.length; j++) {
            if (this.daysOfWeek[index].day === this.serviceTimings[j].day) {
              this.serviceTimings[j].status = 1;
              this.serviceTimings[j].dayName = this.daysOfWeek[index].name 
              this.finalServiceTimings.push(this.serviceTimings[j]);
              dayFound = true;
            }
          }
        
          if (!dayFound) {
            let data = {
              day: this.daysOfWeek[index].day,
              dayName: this.daysOfWeek[index].name,
              hashId: null,
              openTime: '---',
              closeTime: '---',
              operationDate: null,
              specialDayStatus: null,
              toShowType: 'parent',
              status: 0
            };
            this.finalServiceTimings.push(data);
          }
        }
        console.log(this.finalServiceTimings);
        this.groupedServiceTimings = this.groupBy(this.finalServiceTimings, 'dayName');
        this.daysArray = this.getDayNamesFromData(this.finalServiceTimings)
        this.toShowTimings = true
       }
      //  else{
  
      //   this.finalServiceTimings = []
      //   for (let index = 0; index < this.daysOfWeek.length; index++) {
        
        
         
      //       let data = {
      //         day: this.daysOfWeek[index].day,
      //         dayName: this.daysOfWeek[index].name,
      //         hashId: null,
      //         openTime: '---',
      //         closeTime: '---',
      //         operationDate: null,
      //         specialDayStatus: null,
      //         toShowType: 'parent',
      //         status: 0
      //       };
      //       this.finalServiceTimings.push(data);
        
      //   }
      //   this.groupedServiceTimings = this.groupBy(this.finalServiceTimings, 'dayName');
      //   this.toShowTimings = false
      //  }
       this.loaderservice.showLoader = false
       this.loader = false
      }
      if (
        resdata.responseType ===
        SM_CONSTANTS.RESULT_API_UPDATE_ENTITY_HOME_SERVICE_TIMINGS
      ) {
        if (resdata.result) {
          if(this.serviceType == '0'){
            this.apiservice.getHomeServiceTimeDetails(this.entityHashId)
          }
          else if(this.serviceType == '1'){
            this.apiservice.getShopEntityTimeDetails(this.entityHashId)
          }
        }
      }
      if (
        resdata.responseType ===
        SM_CONSTANTS.RESULT_API_UPDATE_ENTITY_SHOP_SERVICE_TIMINGS
      ) {
        if (resdata.result) {
          if(this.serviceType == '0'){
            this.apiservice.getHomeServiceTimeDetails(this.entityHashId)
          }
          else if(this.serviceType == '1'){
            this.apiservice.getShopEntityTimeDetails(this.entityHashId)
          }
        }
      }
      if (
        resdata.responseType ===
        SM_CONSTANTS.RESULT_API_UPDATE_VIRTUAL_SERVICE_TIMINGS
      ) {
        if (resdata.result) {
          if(this.serviceType == '0'){
            this.apiservice.getHomeServiceTimeDetails(this.entityHashId)
          }
          else if(this.serviceType == '1'){
            this.apiservice.getShopEntityTimeDetails(this.entityHashId)
          }
          else if(this.serviceType == '2'){
            this.apiservice.getVirtualServiceTimings(this.entityHashId)
          }
        }
      }
       if(resdata.responseType === SM_CONSTANTS.RESULT_API_GET_VIRTUAL_SERVICE_TIMINGS){
        this.serviceTimings = []
        this.daysArray = []
        this.groupedServiceTimings = null
        this.toShowTimings = false
        if(resdata.result){
          let formattedData = this.formatTimeData(resdata.result)
          // resdata.result.forEach((element:any) => {
          //   element.timeList = JSON.parse(element.timeList)
          // });
  
          console.log(resdata.result);
  
          formattedData.forEach((element:any) => {
          if(element.timeList.length > 1){
            element.timeList.forEach((childItem:any, index:number) => {
              childItem.toShowType = index == 0 ? 'parent' : 'child'
              childItem.closeTime = this.convertTo12HourFormat(childItem.closeTime)
              childItem.openTime = this.convertTo12HourFormat(childItem.openTime)
              this.serviceTimings.push(childItem)
            });
          }else{
            element.timeList[0].toShowType = 'parent'
            element.timeList[0].closeTime = this.convertTo12HourFormat(element.timeList[0].closeTime)
            element.timeList[0].openTime = this.convertTo12HourFormat(element.timeList[0].openTime)
            this.serviceTimings.push(element.timeList[0])
          }
          
        });
  
        console.log(this.serviceTimings);
        
        this.finalServiceTimings = []
        for (let index = 0; index < this.daysOfWeek.length; index++) {
          let dayFound = false; // Flag to keep track if the day was found in serviceTimings
        
          for (let j = 0; j < this.serviceTimings.length; j++) {
            if (this.daysOfWeek[index].day === this.serviceTimings[j].day) {
              this.serviceTimings[j].status = 1;
              this.serviceTimings[j].dayName = this.daysOfWeek[index].name 
              this.finalServiceTimings.push(this.serviceTimings[j]);
              dayFound = true;
            }
          }
        
          if (!dayFound) {
            let data = {
              day: this.daysOfWeek[index].day,
              dayName: this.daysOfWeek[index].name,
              hashId: null,
              openTime: '---',
              closeTime: '---',
              operationDate: null,
              specialDayStatus: null,
              toShowType: 'parent',
              status: 0
            };
            this.finalServiceTimings.push(data);
          }
        }
        console.log(this.finalServiceTimings);
        this.groupedServiceTimings = this.groupBy(this.finalServiceTimings, 'dayName');
        this.toShowTimings = true
        this.daysArray = this.getDayNamesFromData(this.finalServiceTimings)
       }
      //  else{
  
      //   this.finalServiceTimings = []
      //   for (let index = 0; index < this.daysOfWeek.length; index++) {
        
        
         
      //       let data = {
      //         day: this.daysOfWeek[index].day,
      //         dayName: this.daysOfWeek[index].name,
      //         hashId: null,
      //         openTime: '---',
      //         closeTime: '---',
      //         operationDate: null,
      //         specialDayStatus: null,
      //         toShowType: 'parent',
      //         status: 0
      //       };
      //       this.finalServiceTimings.push(data);
        
      //   }
      //   this.groupedServiceTimings = this.groupBy(this.finalServiceTimings, 'dayName');
      //   this.toShowTimings = false
      //  }
       this.loaderservice.showLoader = false
       this.loader = false
      }
    })
  }

  ngOnInit(): void {
    this.serviceType = this.parentdata.serviceType
    // if(this.serviceType == '0'){
    //   this.loaderservice.showLoader = true
    //   this.apiservice.getHomeServiceTimeDetails(this.entityHashId)
    // }
    // else if(this.serviceType == '1'){
    //   this.loaderservice.showLoader = true
    //   this.apiservice.getShopEntityTimeDetails(this.entityHashId)
    // }
    // else if(this.serviceType == '2'){
    //   this.loaderservice.showLoader = true
    //   this.apiservice.getVirtualServiceTimings(this.entityHashId)
    // }
  }

  selectDay(index:any){
    this.daysArray[index].is_selected = this.daysArray[index].is_selected === 1 ? 0 : 1;

  }

  isNoDaySelected(): boolean {
return !this.daysArray.some((day: any) => day.is_selected === 1);}



  onPost(){
  const selectedDays = this.daysArray.filter((item: any) => item.is_selected === 1);

  const obj = selectedDays.map((day: any) => ({
    startTime: this.convertTo24HourFormat(this.fromTime),
    endTime: this.convertTo24HourFormat(this.toTime),
    day: day
  }));
  console.log(obj);
  
  this.activemodal.close(obj);
    
    // this.activemodal.close(obj)
  }

  convertTo12HourFormat(timeString:any) {
  
    const [hours, minutes] = timeString.split(':');
    let period = 'AM';
    let hour = parseInt(hours, 10);
  
    if (hour >= 12) {
      period = 'PM';
      if (hour > 12) {
        hour -= 12;
      }
    }
  
    return `${hour.toString().padStart(2, '0')}:${minutes} ${period}`;
  }
  groupBy(array: any, key: any) {
  // Step 1: Group the input array by the specified key
  const grouped = array.reduce((acc:any, curr:any) => {
    if (!acc[curr[key]]) {
      acc[curr[key]] = [];
    }
    acc[curr[key]].push(curr);
    return acc;
  }, {});
  
  // Step 2: Transform the grouped object into an array of objects with timelist
  return Object.values(grouped).map(timelist => ({ timelist }));
  }
  
  ngOnDestroy(): void {
  this.apisub.unsubscribe()
  }
  

  
  formatTimeData(data: any) {
    const groupedData: { [key: number]: any } = {};
  
    data.forEach((item:any) => {
      const formattedItem = {
        day: item.day,
        hashId: item.hash_id,
        openTime: `${item.open_time}.000000`,
        closeTime: `${item.close_time}.000000`,
        operationDate: null,
        specialDayStatus: item.special_day_status
      };
  
      if (!groupedData[item.day]) {
        groupedData[item.day] = { timeList: [formattedItem] };
      } else {
        groupedData[item.day].timeList.push(formattedItem);
      }
    });
  
    return Object.values(groupedData);
  }

  getDayNamesFromData(data:any) {
    const result:any = {};
      
    data.forEach((entry:any) => {
        if (entry.status === 1) {
            // If the day already exists, add the time slot to the existing day
            if (result[entry.day]) {
                result[entry.day].timeSlots.push({
                    openTime: entry.openTime,
                    closeTime: entry.closeTime
                });
            } else {
                // If the day doesn't exist, create it
                result[entry.day] = {
                    dayName: entry.dayName,
                    day: entry.day,
                    timeSlots: [{
                        openTime: entry.openTime,
                        closeTime: entry.closeTime
                    }],
                    is_selected : 0
                };
            }
        }
    });

    // Convert the result object into an array of objects
    console.log(Object.values(result));
    
    return Object.values(result);
}

selectedTime:any
fromTime:any
toTime:any


getOneHourSlot(timeString:any) {
  // Split the time string into hours and minutes
  let [hours, minutes] = timeString.split(':').map(Number);

  // Adjust hours based on minutes (round down to nearest hour)
  let startHour = hours;

  // Calculate next hour
  let endHour = (startHour + 1) % 24;

  // Format hours to always be 2 digits (e.g., 08:00, 23:00)
  const formatHour = (hour:any) => hour.toString().padStart(2, '0');

  // Return the 1-hour slot in 24-hour format
  return {
    start: `${formatHour(startHour)}:00`,
    end: `${formatHour(endHour)}:00`
  };
}
convertTo24HourFormat(time:any) {
  // Extract hours, minutes, and AM/PM from the time string
  const [timePart, amPm] = time.split(' ');
  const [hoursStr, minutesStr] = timePart.split(':');

  // Convert string components to numbers
  let hours = parseInt(hoursStr, 10);
  const minutes = parseInt(minutesStr, 10);

  // Adjust hours based on AM/PM
  if (amPm.toLowerCase() === 'pm' && hours !== 12) {
      hours += 12;
  } else if (amPm.toLowerCase() === 'am' && hours === 12) {
      hours = 0;
  }

  // Construct a new Date object with a fixed date and the parsed time components
  const date = new Date(2000, 0, 1, hours, minutes);

  // Use Date methods to get hours, minutes, and seconds in 24-hour format
  const formattedHours = date.getHours().toString().padStart(2, "0");
  const formattedMinutes = date.getMinutes().toString().padStart(2, "0");

  const formattedTime = `${formattedHours}:${formattedMinutes}`;

  console.log(formattedTime);

  return formattedTime;
}

}
